(ns frontend.view.grid.real-estates-grid.db
  (:require
   [frontend.db :as app-db]
   [reagent.core :as r]
   [common.entity :as entity]
   [common.util :as cu]
   [frontend.state.current-session :as session]))

(defonce real-estates (r/cursor app-db/views [:real-estates-grid]))
(defonce modal-state (r/cursor real-estates [:modals]))
(defonce grid-entities (r/cursor real-estates [:grid-entities]))
(defonce view-settings (r/cursor real-estates [:view-settings]))
(defonce real-estate-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor real-estates [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor real-estates [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor real-estates [:schema]))
